import { isEmpty, values, pick } from 'ramda';

import { withEmptyRendering } from './withEmptyRendering';

type InvalidProps<T> = { [key in keyof T]?: T[key] | null | undefined };

export function withEmptyRenderingOneOf<T, K extends keyof T = keyof T>(keys: K[]) {
  return withEmptyRendering<T | (Omit<T, K> & InvalidProps<Pick<T, K>>)>(validator<T, K>(keys));
}

function validator<T, K extends keyof T>(keys: K[]) {
  return (props: T) => {
    const checkProps = pick(keys as string[], props);
    const valuesProps = values(checkProps);

    return !valuesProps.some(prop => prop && !isEmpty(prop));
  };
}
